import { call, put, takeLatest, select } from 'redux-saga/effects'
import { Api } from '../api/api'
import { AxiosError } from 'axios'
import {
  AppError,
  GET_COUNTERS,
  GetCounters,
  GetClients,
  GET_CLIENTS,
  ClientsPayload,
  LOG_OUT,
  LogoutAction,
  State,
} from '../store/types'
import { setAppError, setClients, setCounters } from '../store/actions'
import { LocalStorage } from '../utils/localStorage'

const transformHttpErrorToAppError = (e: AxiosError) => {
  const { response } = e
  if (response?.status === 403) {
    return AppError.Forbidden
  }

  if (response?.status === 404) return AppError.IncorrectToken

  if (response?.status === 500) {
    return AppError.InternalServerError
  }

  if (response?.status === 503) {
    return AppError.ServiceUnavailable
  }

  return AppError.Other
}

// TODO: delete
function* getCounters(action: GetCounters) {
  try {
    // @ts-ignore
    const token = yield select((state: State) => state.app.token)
    // @ts-ignore
    const response = yield call(Api.getCounters, token)

    // const response = mockCounters
    yield put(setCounters(response.data))
    // yield put(push('/status'))
  } catch (e) {
    yield put(setAppError(transformHttpErrorToAppError(e)))
  }
}

function* getClients(action: GetClients) {
  try {
    // @ts-ignore
    const token = yield select((state: State) => state.app.googleToken)
    // @ts-ignore
    const response = yield call(Api.getClients, token)

    yield put(setClients(response.data as unknown as ClientsPayload))
  } catch (e) {
    yield put(setAppError(transformHttpErrorToAppError(e)))
  }
}

function* logout(action: LogoutAction) {
  LocalStorage.cleanGoogleToken()
  // TODO: check
  window.location.replace('/')
  // yield put(push('/'))
}

function* AppSaga() {
  yield takeLatest(GET_COUNTERS, getCounters)
  yield takeLatest(LOG_OUT, logout)
  yield takeLatest(GET_CLIENTS, getClients)
}

export default AppSaga
